var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A0867E84-0AD1-4530-AD6B-30BB8E6F19C1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Operations--Payments-CT1",
    transform: "translate(-602.000000, -838.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(284.000000, 138.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info-(1)",
    transform: "translate(318.125957, 700.285891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6001403,5.80014028 C11.6001403,2.59657524 9.00335462,0 5.80016366,0 C2.59680904,0 0,2.59657524 0,5.80014028 C0,9.00321434 2.59680904,11.6 5.80016366,11.6 C9.00335462,11.6 11.6001403,9.00321434 11.6001403,5.80014028 Z",
    id: "Path",
    fill: "#99B4CC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.080063, 1.614899)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.29043766,6.79140263 C3.25800969,6.74389461 3.19579569,6.72699092 3.14384548,6.75160999 C2.56911999,7.02368226 1.91681989,7.31132556 1.78879139,7.33645899 C1.78556495,7.33358326 1.78044475,7.32832277 1.77373471,7.31922798 C1.7563868,7.29573115 1.74794664,7.2650333 1.74794664,7.22535755 C1.74794664,6.9002596 1.99331903,5.91128848 2.47721348,4.28605589 C2.88521667,2.92052758 2.93239738,2.63779406 2.93239738,2.54392364 C2.93239738,2.39901482 2.8769168,2.27657411 2.77189414,2.18981119 C2.67213197,2.10753721 2.53274082,2.06585079 2.35762513,2.06585079 C2.06633456,2.06585079 1.72872834,2.17643787 1.32549465,2.40394798 C0.934745851,2.62449088 0.498967299,2.99803205 0.0303399432,3.51419081 C-0.00634317005,3.55461471 -0.0101774789,3.61505184 0.0211048701,3.65980103 C0.0524339789,3.7045736 0.11053311,3.72161757 0.161057143,3.70104323 C0.325581724,3.63389606 1.15241302,3.29519099 1.27293657,3.21948677 C1.37162326,3.15762347 1.45705353,3.12622422 1.52686601,3.12622422 C1.52936766,3.12622422 1.53151861,3.12631774 1.53331887,3.12645802 C1.53416055,3.13108725 1.53495546,3.13814799 1.53495546,3.1482715 C1.53495546,3.21951015 1.52029625,3.30384156 1.49156231,3.39850691 C0.786984681,5.68134685 0.444492058,7.08079943 0.444492058,7.67689418 C0.444492058,7.88726681 0.502965268,8.05663103 0.618251712,8.18021735 C0.73573587,8.30630533 0.894205049,8.37022606 1.08926382,8.37022606 C1.2971348,8.37022606 1.55012904,8.28339299 1.86267197,8.10477031 C2.16511477,7.93194586 2.62672815,7.55176478 3.2739548,6.94239024 C3.31587502,6.90294829 3.32286562,6.83891066 3.29043766,6.79140263 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26782926,0.177617343 C3.1526831,0.0597591061 3.00534276,0 2.82994652,0 C2.61157795,0 2.4213822,0.0862953289 2.26471328,0.256501233 C2.11054601,0.423901546 2.03236352,0.629317628 2.03236352,0.867021397 C2.03236352,1.05483239 2.08994829,1.2104726 2.20350462,1.32959335 C2.31858064,1.45051436 2.46393368,1.51181654 2.63547224,1.51181654 C2.84490967,1.51181654 3.0340767,1.42068157 3.19768947,1.24093665 C3.35844988,1.06434802 3.43997571,0.856734227 3.43997571,0.623870104 C3.43999908,0.444920105 3.38208699,0.294797562 3.26782926,0.177617343 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9cd8cfd54f6617be0918dd0cd0789a91.svg";
export { ForwardRef as ReactComponent };